import React, { useEffect, useState } from 'react';
import allImgPaths from 'assets/images';
import RfpDrag from './rfpInnerBox/RfpDrag';
import ConfirmationModal from 'components/common/modal/ConfirmationModal';

const RfpName = ({ data: dataObj, index, setItemData, removeItem, dragItem }: any) => {
    const [data, setData] = useState(dataObj.content || '')
    const [isChecked, setIsChecked] = useState(dataObj?.showLabel || false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setData(dataObj.content)
        }
    }, [dataObj?.updatedTime])

    const handleCheckboxChange = (isChecked: boolean) => {
        setIsChecked(isChecked);
        setItemData({ index, content: data, showLabel: isChecked })
    };

    const handleChange = (e: any) => {
        const inputVal = e.target.value;
        if (dataObj?.type == 'text') setData(inputVal)

        if (dataObj?.type == 'number') {
            if (isNaN(inputVal)) {
                setData(data)
                return
            }

            setData(inputVal)
        }
        setItemData({ index, content: inputVal, showLabel: isChecked })
    };

    const remove = () => {
        setShowDeleteModal(true)
    }

    const confirmDelete = () => {
        removeItem({ index })
    }

    const drag = (position: string) => {
        dragItem({ index, position })
    }

    return (
        <>
            {
                showDeleteModal &&
                <ConfirmationModal
                    headerText={'Delete'}
                    bodyText={``}
                    setShowDeleteModal={setShowDeleteModal} confirmDelete={confirmDelete}
                />
            }

            <div className="border border-[#F0F0F0] bg-[#F9F9F9] rounded-sm flex mb-6 last:mb-6">
                {/* Drag */}
                <RfpDrag dragItem={drag} />

                {/* Content */}
                <div className="w-full py-2 pr-2">
                    <div className="mb-2 flex justify-between items-center px-0.5">
                        <span className='font-interMedium text-sm text-[#344054]'>{dataObj.title}</span>
                        <div className='rfp-custom-checkbox'>
                            <input
                                type='checkbox'
                                name={'rfpName'}
                                checked={isChecked || false}
                                onChange={(e) => handleCheckboxChange(e.target.checked)}
                                style={{ width: '16px', height: '18px', cursor: 'pointer' }}
                            />
                            <label
                                className={`font-interMedium`}
                            >
                                <span className={`custom-checkbox-label font-interMedium text-sm text-[#667085] pl-1.5`}>Show label in draft</span>
                            </label>
                        </div>
                    </div>

                    <div className="border border-[#EAECF0] rounded-lg px-4 py-3 bg-[#fff] flex items-center group">
                        <input
                            onChange={handleChange}
                            className='w-full placeholder:text-base placeholder:text-[#D0D5DD] pr-4'
                            placeholder='Enter here'
                            type="text"
                            value={data}
                        />

                        <img className='cursor-pointer hidden group-hover:block' src={allImgPaths.closeIconRed} alt="" onClick={remove} />
                    </div>
                </div>

            </div>
        </>
    );
};

export default RfpName;
